import {AppState} from '../reducer';
import {IConnectionStatus} from '../../incase-domain/connectionStatus';

export const connectionStatusSelector = (state: AppState): IConnectionStatus => state.connectionStatusReducer.connectionStatus;
